import { getCirugia, postCirugia } from "./ApiHIS"

export const postDespachoQxBodegaFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/bodegas',body)
}

export const postListaPersonalEnfermeriaFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/dmedico',body)
}

export const postTipoProfesionarDespachoQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/enfermerod',body)
}

export const getTipoDocumentoDespachoQxFarmacia=()=>{
    return getCirugia('cirugias/programacion/tipo')
}

export const postTablaPrincipalDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/tprincipal',body)
}

export const postQuirofanosFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/quirofano',body)
}

export const postDataDevolucionesQx=(body)=>{
    return postCirugia('cirugias/devoluciones/principal',body)
}

export const postUpdateUserDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/update/user',body)
}

export const postUltimoConsecutivoDocNumAcADespachoQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/numeroactual',body)
}

export const postActualizarEstadoSuministroDespachoQx=(body)=>{
    return postCirugia('cirugias/despacho/update/estado',body)
}

export const postActualizarDocNumAcADespachoQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/numeroactual/update',body)
}

export const postDespacharSuministrosDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/pedpad/insert',body)
}

export const postActualizarUserDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/update/codcir',body)
}

export const postActualizarUserDevolucionesQx=(body)=>{
    return postCirugia('cirugias/devoluciones/update/usuario',body)
}

export const postVerSuministrosDespachosQxFarmacia=(body)=>{
    //return postCirugia('despacho/info/sumi',body)
    return postCirugia('cirugias/despacho/estado/pedpad',body)
}

export const postVerSuministrosDespachadosPaqueteNoventaYCuatroQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/paquete/generico',body)
}

export const postDespacharPaquetesFarmaciaQX=(body)=>{
    return postCirugia('cirugias/despacho/optimizar/despachos',body)
}

export const postInsertarDataDevolucionesQx=(body)=>{
    return postCirugia('cirugias/devoluciones/insert/sumindev/copia',body)
}

export const postEstadosDelDespachoDevolucionQxFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/estado/despacho',body)
}

export const postEstadoPaqueteFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/estado/gasto',body)
}

export const postActualizarEstadoSuministroDevolucionesQxFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/update/estado',body)
}

export const postActualizarUserDevolucionesQxFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/update/codcir',body)
}

export const postPDFDevolucionesQxFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/pdf',body)
}

export const postSuministrosDevolucionesQxFarmacia=(body)=>{
    return postCirugia('cirugias/devoluciones/table',body)
}

export const postInconsistenciaDevolucionesQx=(body)=>{
    return postCirugia('cirugias/devoluciones/inconsistencia/dupli/pdf',body)
}

export const postDataSuministrosDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/data/insert11',body)
}

export const postMotivoDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/cancelar/paquete',body)
}

export const postCancelarDespachosQxFarmacia=(body)=>{
    return postCirugia('cirugias/despacho/cancelar/update',body)
}

// Estadisticas
export const totalSuministrosSolicitadosDespachadosUsadosDevueltos=()=>{
    return getCirugia('cirugias/suministro/suministrosTotalSolicitadosDespachadosUsadosDevueltos')
}

export const getTotalProcedimientosQx=()=>{
    return getCirugia('cirugias/cantidadProcedimientosRealizados')
}

export const postPaqueteNoventaCuatroDespachosQx=(body)=>{
    return postCirugia('cirugias/despacho/estado/pedpad/generico',body)
}

//reimprimir despacho
// export const postReimprimirDespachoPrincipal=(body)=>{
//     return postCirugia('despacho/reimprimir',body)
// }
export const postReimprimirDespachoPrincipal=(body)=>{
    return postCirugia('cirugias/despacho/reimprimir',body)
}

export const getTipoDocumento=()=>{
    return postCirugia('cirugias/despacho/reimprimir/tipoDoc')
}

export const postPDFReimprimirDespachos=(body)=>{
    //return postCirugia('cirugias/reimprimir/info/pdf',body)
    return postCirugia('cirugias/despacho/reimprimir/datos/pdf',body)
}

export const postActivarUpdatePaquete=(body)=>{
    return postCirugia('cirugias/actua/estdesp',body)
}

export const postImprimirDespachosQx=(body)=>{
    return postCirugia('cirugias/imprimir/despachosqx',body)
}

